import axios from '@axios'

export default {
  list: pagina => axios.get(`${process.env.VUE_APP_WCOND_API}/ocorrencias/${pagina}`),
  obter: id => axios.get(`${process.env.VUE_APP_WCOND_API}/ocorrencia/${id}`),
  listEventos: id => axios.get(`${process.env.VUE_APP_WCOND_API}/ocorrencia/evento/${id}`),
  gravarEvento: evento => axios.post(`${process.env.VUE_APP_WCOND_API}/ocorrencia/evento`, evento),
  gravarOcorrencia: ocorrencia => axios.post(`${process.env.VUE_APP_WCOND_API}/ocorrencia`, ocorrencia),
}
